<block-ui>
  <router-outlet></router-outlet>
</block-ui>
<notifier-container></notifier-container>